import { Fragment } from 'react'
import { useCMSPageField } from '@/cms/fields'
import { CheckoutMessage } from '@/scopes/checkout/components/CheckoutMessage'
import { ParticipantsBadgeForm } from '@/scopes/checkout/components/ParticipantsBadgeForm/ParticipantsBadgeForm'
import { BookingRedeemerService } from '@/scopes/checkout/components/services/BookingRedeemerService'
import { BridgeService } from '@/scopes/checkout/components/services/BridgeService'
import { CancellationInsuranceService } from '@/scopes/checkout/components/services/CancellationInsuranceService'
import { CarRentalFilteringService } from '@/scopes/checkout/components/services/CarRentalFilteringService'
import { DinnerVouchersService } from '@/scopes/checkout/components/services/DinnerVouchersService'
import { getGenericServiceComponent } from '@/scopes/checkout/components/services/getGenericServiceComponent'
import { GolfService } from '@/scopes/checkout/components/services/GolfService/GolfService'
import { LuggageService } from '@/scopes/checkout/components/services/LuggageService'
import { SkiPassService } from '@/scopes/checkout/components/services/SkiAncillariesService'
import { SkiLessonService } from '@/scopes/checkout/components/services/SkiAncillariesService/SkiLessonService'
import { SkiMaterialService } from '@/scopes/checkout/components/services/SkiAncillariesService/SkiMaterialService'
import { useCheckoutSid } from '@/scopes/checkout/domain/hooks'
import { ServiceTypeApi } from '@/scopes/checkout/infrastructure/api/types'

export function Services() {
  const sid = useCheckoutSid()
  const items = useCMSPageField('Checkout.items')?.items ?? []
  if (!sid || !items) {
    return null
  }
  return (
    <>
      {items.map((item, index) => {
        const { type, componentId, aName } = item
        switch (type) {
          case ServiceTypeApi.ConditionalMessages:
            return <CheckoutMessage key={`${type}-${index}`} componentId={componentId} />
          case ServiceTypeApi.BookingRedeemer:
            return <BookingRedeemerService key={`${type}-${index}`} item={item} />
          case ServiceTypeApi.ParticipantsBadge:
            return <ParticipantsBadgeForm key={`${type}-${index}`} />
          case ServiceTypeApi.SkiAncillaries:
            return (
              <Fragment key={`${type}-${index}`}>
                <SkiPassService key={`SkiPass-${index}`} />
                <SkiMaterialService key={`SkiMaterial-${index}`} />
                <SkiLessonService key={`SkiLesson-${index}`} />
              </Fragment>
            )
          case ServiceTypeApi.Luggage:
            return <LuggageService item={item} key={`${type}-${index}`} />
          case ServiceTypeApi.CarRental:
            return <CarRentalFilteringService item={item} key={`${type}-${index}`} />
          case ServiceTypeApi.CancellationInsurance:
            return <CancellationInsuranceService key={`${type}-${index}`} item={item} />
          case ServiceTypeApi.Golf:
            return <GolfService key={`${type}-${index}`} item={item} />
          case ServiceTypeApi.GenericPerUnitComponent:
            if (aName === 'MEAL-VOUCHERS') {
              return <DinnerVouchersService key={`${type}-${index}`} item={item} />
            }
            return null
          case ServiceTypeApi.GenericPerParticipantSelection:
            if (aName === 'BRIDGE') {
              return <BridgeService key={`${type}-${index}`} item={item} />
            }
            return null
          case ServiceTypeApi.Generic:
            return getGenericServiceComponent(aName ?? '', item, type, index)
          default:
            if (window.newrelic) {
              const error = new Error(`[CheckoutSteps] No service ${type} found`)
              window.newrelic.noticeError(error)
            }
            return null
        }
      })}
    </>
  )
}
